import { render, staticRenderFns } from "./sharePoster.vue?vue&type=template&id=660214f6&scoped=true&"
import script from "./sharePoster.vue?vue&type=script&lang=js&"
export * from "./sharePoster.vue?vue&type=script&lang=js&"
import style0 from "./sharePoster.vue?vue&type=style&index=0&id=660214f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660214f6",
  null
  
)

export default component.exports